// Matching a scanned vehicle tag ("v|{vehicleId}|{vrm}") against the vehicle
// on the job in view. The id is authoritative when it agrees, but a label can
// carry a different id for the same car (a second Vehicle row for that reg, or
// a keyboard-wedge scanner dropping a character from the GUID), so the reg
// printed on the tag is accepted as a match too - it's what the operator is
// actually looking at.

/** The QR encodes a missing reg as the literal "NULL". */
const NULL_VRM = "NULL";

/** Uppercase, no whitespace, so "fh62 wmv" and "FH62WMV" compare equal. */
export const normaliseVrm = (vrm?: string | null): string =>
  (vrm ?? "").replace(/\s+/g, "").toUpperCase();

export interface ScannedVehicle {
  id?: string;
  vrm?: string;
}

export interface VehicleIdentity {
  id?: string | null;
  vrm?: string | null;
}

export function scanMatchesVehicle(
  scanned: ScannedVehicle,
  vehicle: VehicleIdentity | undefined | null
): boolean {
  if (!vehicle) return false;

  const scannedId = scanned.id?.trim().toLowerCase();
  const vehicleId = vehicle.id?.trim().toLowerCase();
  if (scannedId && vehicleId && scannedId === vehicleId) return true;

  const scannedVrm = normaliseVrm(scanned.vrm);
  const vehicleVrm = normaliseVrm(vehicle.vrm);
  if (!scannedVrm || scannedVrm === NULL_VRM || !vehicleVrm) return false;

  return scannedVrm === vehicleVrm;
}
